export enum QueryParmEnum {
    projectId = 'projectId',
    cubicleId = 'cubicleId',
    userId = 'userId'
}